var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5744_588190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5744_588190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29905 18.4984H14.693C14.9477 18.4984 15.1625 18.4127 15.3375 18.2412C15.5125 18.0697 15.6 17.8572 15.6 17.6037C15.6 17.3502 15.5139 17.1359 15.3416 16.9609C15.1693 16.7859 14.9558 16.6984 14.701 16.6984H9.30712C9.05241 16.6984 8.83755 16.7842 8.66255 16.9557C8.48755 17.1272 8.40005 17.3397 8.40005 17.5932C8.40005 17.8467 8.4862 18.0609 8.6585 18.2359C8.83082 18.4109 9.04433 18.4984 9.29905 18.4984ZM9.29905 14.8984H14.693C14.9477 14.8984 15.1625 14.8127 15.3375 14.6412C15.5125 14.4697 15.6 14.2572 15.6 14.0037C15.6 13.7502 15.5139 13.5359 15.3416 13.3609C15.1693 13.1859 14.9558 13.0984 14.701 13.0984H9.30712C9.05241 13.0984 8.83755 13.1842 8.66255 13.3557C8.48755 13.5272 8.40005 13.7397 8.40005 13.9932C8.40005 14.2467 8.4862 14.4609 8.6585 14.6359C8.83082 14.8109 9.04433 14.8984 9.29905 14.8984ZM6.59297 22.0984C6.09769 22.0984 5.67505 21.9222 5.32505 21.5697C4.97505 21.2172 4.80005 20.7934 4.80005 20.2984V4.69844C4.80005 4.20344 4.9763 3.77969 5.3288 3.42719C5.6813 3.07469 6.10505 2.89844 6.60005 2.89844H13.65C13.8871 2.89844 14.113 2.9401 14.3278 3.02344C14.5426 3.10677 14.7417 3.2401 14.925 3.42344L18.675 7.17344C18.8584 7.35677 18.9917 7.55585 19.0751 7.77066C19.1584 7.98548 19.2 8.2114 19.2 8.44844V20.2984C19.2 20.7934 19.0237 21.2172 18.671 21.5697C18.3183 21.9222 17.8943 22.0984 17.3991 22.0984H6.59297ZM13.2 7.99844V4.69844H6.60005V20.2984H17.4V8.89844H14.1C13.845 8.89844 13.6313 8.81219 13.4588 8.63969C13.2863 8.46719 13.2 8.25344 13.2 7.99844Z",
    fill: "#1F6CF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrDocument);
export default __webpack_public_path__ + "static/media/ocr-document.e641d70e1179573e21ee17cbdd50eeee.svg";
export { ForwardRef as ReactComponent };